export default function ConfiguredDevices(){
    return (
        <div>Configured Devices</div>
    )
}